import React, { useState, useEffect } from 'react'
import { authorization } from 'Module/Auth/Auth'
import { urlGet } from './../../Utils/URL'
import View from './View'

import {
  fetchAllClientsByChunks,
  fetchCampaignsData,
} from 'Containers/Campaigns/gql.js'

import { INVENTORY_FLYER_ITEM_TYPE } from 'shared/constants'
import {
  CAMPAIGN_ENUM_TYPES,
  STATUS_CAMPAIGN_ENUM_ACTIVE,
  STATUS_CAMPAIGN_ENUM_ARCHIVE,
  STATUS_CAMPAIGN_ENUM_DRAFT,
  STATUS_FILTER_OPTIONS,
} from '../../shared/constants'
import { SOURCE_OPTIONS } from '../../constants'
import { CONFIG } from '../../Config/config'

export default props => {
  const [filters, setFilters] = useState(null)
  const allowedOrigins = [CONFIG.NEXT_BASE_URL]

  const user = authorization.getUser()
  const isClient = authorization.isClient()

  useEffect(() => {
    const handleMessageOld = event => {
      if (allowedOrigins.includes(event.origin) && event.data === 'message') {
        const token = JSON.stringify(localStorage.apiKey)
        event.source.postMessage(token, event.origin)
      }
    }
    window.addEventListener('message', handleMessageOld)

    return () => {
      window.removeEventListener('message', handleMessageOld)
    }
  }, [])

  const loadFilters = async () => {
    const { clients, countries } = await fetchAllClientsByChunks({
      chunkSize: 100,
    })

    setFilters([
      {
        label: 'Status',
        options: STATUS_FILTER_OPTIONS,
        selectedValue: urlGet('Status'),
      },
      {
        label: 'Country',
        options: countries.map(c => ({
          label: c.name,
          value: c.id,
        })),
        selectedValue: urlGet('Country') || user.countryName,
      },
      {
        label: 'Source',
        options: SOURCE_OPTIONS,
        selectedValue: urlGet('Source'),
      },
      {
        label: 'Channel',
        options: [
          {
            label: 'Hand to hand',
            value: CAMPAIGN_ENUM_TYPES.HANDTOHAND,
          },
          {
            label: 'Letterbox',
            value: CAMPAIGN_ENUM_TYPES.LETTERBOX,
          },
          {
            label: 'Direct Mail',
            value: CAMPAIGN_ENUM_TYPES.DIRECTMAIL,
          },
          {
            label: 'Inserts',
            value: CAMPAIGN_ENUM_TYPES.INSERTS,
          },
        ],
        selectedValue: urlGet('Channel'),
      },
      {
        label: 'Client',
        options: clients.map(c => ({
          label: c.name,
          value: c.id,
          countryId: c.countryId,
        })),
        selectedValue: urlGet('Client'),
      },
      {
        label: 'startDate',
        options: [],
        selectedValue: undefined,
      },
      {
        label: 'endDate',
        options: [],
        selectedValue: undefined,
      },
    ])
  }

  // Get all the filter options
  useEffect(() => {
    loadFilters()
  }, [])

  const fetchData = async args => {
    const {
      first,
      skip,
      Status,
      Channel,
      Country,
      Client,
      startDate,
      endDate,
      Campaign,
      Source,
      orderBy,
    } = args

    const startDatePeriod = args['Start Date']
    const endDatePeriod = args['End Date']

    const shouldFetchActiveDates = [
      STATUS_CAMPAIGN_ENUM_ARCHIVE,
      STATUS_CAMPAIGN_ENUM_ACTIVE,
      STATUS_CAMPAIGN_ENUM_DRAFT,
      undefined,
    ].includes(Status)

    const variables = {
      first,
      skip,
      statuses: Status ? [Status] : undefined,
      types: Channel ? [Channel] : undefined,
      countryIds: Country ? [Country] : undefined,
      clientIds: Client ? [Client] : undefined,
      startDate: startDate
        ? startDate
        : startDatePeriod
        ? startDatePeriod
        : undefined,
      endDate: endDate ? endDate : endDatePeriod ? endDatePeriod : undefined,
      clientId: isClient ? user.client.id : undefined,
      typeId: INVENTORY_FLYER_ITEM_TYPE,
      campaignIds: Campaign ? Campaign : undefined,
      isSelfServe: Source,
      hasLastConversionDate: true,
      orderBy,
    }

    return await fetchCampaignsData({
      // isClient,
      shouldFetchActiveDates,
      variables,
    })
  }

  if (!filters) return <div>Loading filters...</div>

  return <View {...props} filters={filters} fetchData={fetchData} />
}
